import { PageContentWrapper } from '@lmc/ui-kit'
import useHomeType from 'hooks/useHomeType'
import { RotaPatternView } from '../RotaPattern/RotaPatternView'

export const RotaViewVisitsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContentWrapper
      $gap={12}
      $paddingTop={24}
      $paddingX={48}
      $paddingBottom={24}
    >
      <RotaPatternView type="visit" />
    </PageContentWrapper>
  )
}
